import {
    FolderShared as FolderSharedIcon,
    SupervisorAccount as SupervisorAccountIcon,
    Folder as FolderIcon,
    PersonOutlineOutlined as PersonOutlineOutlinedIcon,
  } from "@mui/icons-material";
  
  export const getOrgActionItems = (setSAdminBase) => [
    {
      id: "add-folder",
      prefix: <FolderIcon sx={{ marginRight: "10px" }} />,
      label: "Add Folder",
      onClick: () => {
        setSAdminBase((prev) => ({ ...prev, addFolderModalOpen: true }));
      },
    },
    {
      id: "add-cohort",
      prefix: <FolderSharedIcon sx={{ marginRight: "10px" }} />,
      label: "Add Cohort",
      onClick: () => {
        setSAdminBase((prev) => ({ ...prev, addCohortModalOpen: true }));
      },
    },
    {
      id: "add-team",
      prefix: <SupervisorAccountIcon sx={{ marginRight: "10px" }} />,
      label: "Add Team",
      onClick: () => {
        setSAdminBase((prev) => ({ ...prev, addTeamModalOpen: true }));
      },
    },
    {
      id: "add-user",
      prefix: <PersonOutlineOutlinedIcon sx={{ marginRight: "10px" }} />,
      label: "Add User",
      onClick: () => {},
    },
  ];
  